export default {
	project_name: 'CRM Play',
	see_the_full_ranking: 'Afficher plus',
	company_agency: 'Magasin',
}
